import {CtModelRouteData} from "@ctsolution/ct-framework";

export const CompanyPlaceRouteData = (): CtModelRouteData => CtModelRouteData
  .create()
  .setController("companyplace");
